// Deterministic tag-pill colors, Jira-style.
//
// Each tag gets a stable bg/text/ring triple based on a hash of its label —
// "frontend" is always the same green, "blocker" is always the same red. The
// palette was picked to read well on white *and* on the slate-100 column
// background of the Kanban board, so we don't need a per-context override.
//
// Consumers:
//   • Kanban card chip strip
//   • Task sheet "Tags" sidebar row
//   • List view tag column

const TAG_PALETTE = [
  { bg: 'bg-blue-50',    text: 'text-blue-700',    ring: 'ring-blue-200' },
  { bg: 'bg-emerald-50', text: 'text-emerald-700', ring: 'ring-emerald-200' },
  { bg: 'bg-violet-50',  text: 'text-violet-700',  ring: 'ring-violet-200' },
  { bg: 'bg-rose-50',    text: 'text-rose-700',    ring: 'ring-rose-200' },
  { bg: 'bg-amber-50',   text: 'text-amber-800',   ring: 'ring-amber-200' },
  { bg: 'bg-cyan-50',    text: 'text-cyan-700',    ring: 'ring-cyan-200' },
  { bg: 'bg-fuchsia-50', text: 'text-fuchsia-700', ring: 'ring-fuchsia-200' },
  { bg: 'bg-teal-50',    text: 'text-teal-700',    ring: 'ring-teal-200' },
  { bg: 'bg-orange-50',  text: 'text-orange-800',  ring: 'ring-orange-200' },
  { bg: 'bg-indigo-50',  text: 'text-indigo-700',  ring: 'ring-indigo-200' },
];

// Names that carry meaning we should honor with a fixed color rather than the
// hash bucket — keeps semantics consistent across tenants. Lowercased keys.
const SEMANTIC = {
  blocker: { bg: 'bg-red-50',     text: 'text-red-700',     ring: 'ring-red-200' },
  blocked: { bg: 'bg-red-50',     text: 'text-red-700',     ring: 'ring-red-200' },
  bug:     { bg: 'bg-rose-50',    text: 'text-rose-700',    ring: 'ring-rose-200' },
  hotfix:  { bg: 'bg-orange-50',  text: 'text-orange-800',  ring: 'ring-orange-200' },
  done:    { bg: 'bg-emerald-50', text: 'text-emerald-700', ring: 'ring-emerald-200' },
  ready:   { bg: 'bg-emerald-50', text: 'text-emerald-700', ring: 'ring-emerald-200' },
  release: { bg: 'bg-indigo-50',  text: 'text-indigo-700',  ring: 'ring-indigo-200' },
};

function hashKey(key = '') {
  let h = 0x811c9dc5;
  const s = String(key).toLowerCase();
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = (h + ((h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24))) >>> 0;
  }
  return h;
}

export function getTagColor(label = '') {
  const k = String(label || '').trim().toLowerCase();
  if (!k) return TAG_PALETTE[0];
  if (SEMANTIC[k]) return SEMANTIC[k];
  return TAG_PALETTE[hashKey(k) % TAG_PALETTE.length];
}
